import React from 'react';
import { NavLink } from 'react-router-dom';

const RegistrarNav = ({ items = [], onNavigate, horizontal = false }) => (
  <nav className={horizontal ? 'flex items-center gap-1' : 'space-y-1'}>
    {items.map((item) => (
      <NavLink
        key={item.to}
        to={item.to}
        end={item.end}
        onClick={onNavigate}
        className={({ isActive }) =>
          horizontal
            ? `md-navbar-link ${isActive ? 'md-navbar-link-active' : ''}`
            : `md-sidebar-link ${isActive ? 'md-sidebar-link-active' : ''}`
        }
      >
        {item.icon && <item.icon className="h-4 w-4 flex-shrink-0 opacity-90" />}
        <span>{item.label}</span>
      </NavLink>
    ))}
  </nav>
);

export default RegistrarNav;
